import styled from "styled-components";

import { colors } from "@/styles/variables";

export const Container = styled.div`
  color: ${colors.errorColor};
  margin-bottom: 5px;
`;
